// import React from "react";
// import { useDropzone } from "react-dropzone";

// const DropzoneComponent = ({ palletIndex, onDrop }) => {
//   const { getRootProps, getInputProps } = useDropzone({
//     accept: "image/*",
//     multiple: true,
//     onDrop: (acceptedFiles) => onDrop(acceptedFiles, palletIndex),
//   });

//   return (
//     <div {...getRootProps()}>
//       <input {...getInputProps()} />
//       <p
//         style={{
//           border: "2px dashed gray",
//           padding: "30px",
//           textAlign: "center",
//         }}
//       >
//         Drag and drop images, or click to select
//       </p>
//     </div>
//   );
// };

// export default DropzoneComponent;
import React from "react";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";

const DropzoneComponent = ({ palletIndex, onDrop }) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    multiple: true,
    onDrop: (acceptedFiles) => onDrop(acceptedFiles, palletIndex),
  });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <p
        style={{
          border: "2px dashed gray",
          padding: "30px",
          textAlign: "center",
        }}
      >
        Drag and drop images, or click to select
      </p>
    </div>
  );
};

// ✅ Add PropTypes validation
DropzoneComponent.propTypes = {
  palletIndex: PropTypes.number.isRequired,
  onDrop: PropTypes.func.isRequired,
};

export default DropzoneComponent;

